module.exports = "/wp-content/plugins/farmacy/assets/js/images/search-icon-565a8de5b9acd526881e93e9880edf72.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/header-control-bar/search-button/img/search-icon.svg
 ** module id = 571
 ** module chunks = 1 27 28 135
 **/